<template>
  <component
    :is="comName"
    ref="com"
  />
</template>
<script>
import Edit from './editForm';
import injuredForm from './injuredForm';
import { api } from '@/plugins/api';
import { Mutations } from '@/store/mutations';
export default {
  name: 'Accident',
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (this.comName === Edit && from.name === 'AccidentAdd') {
      this.$store.commit('app/SET_VIDEODATA', {type:0});
      if (String(this.$refs.com.accident.claim)==='null') {
        this.$confirm('确定离开房间？您还未暂存或提交工单')
        .then(() => {
          if (!this.$refs.com.$refs.video.isStreams()) {
            sessionStorage.setItem('exitId',from.params.id);
          }
          this.$refs.com.$refs.video.leave().then(() => {
            api.video.trtc.ready.r().then((res)=> {
              if (res.code === '200') {
                this.$store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
              }
            }); // 就绪请求
            this.$store.dispatch('tagsView/delView', this.$route); // 修改退出房间状态
            next();
          });
        })
        .catch(() => {
          next(false);
        });
      }else {
        // 只要退出房间则调用离开房间操作
        if (!this.$refs.com.$refs.video.isStreams()) {
          sessionStorage.setItem('exitId',from.params.id);
        }
        this.$refs.com.$refs.video.leave().then(() => {
            api.video.trtc.ready.r().then((res)=> {
              if (res.code === '200') {
                this.$store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
              }
            }); // 就绪请求
            next();
          });
      }
      localStorage.setItem('isReady','1');
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.comName === Edit && from.name === 'AccidentAdd') {
      this.$confirm('确定离开当前房间？')
        .then(() => {
          this.$refs.com.$refs.video.leave().then(() => {
            next();
          });
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  data() {
    return {
      comName: ''
    };
  },
  computed: {
    roles() {
      return this.$store.getters.roles;
    },
    dictCode() {
      return localStorage.getItem('loginType');
    }
  },
  created() {
    const admin = this.roles.includes('admin');
    const Agent = this.roles.includes('Agent');
    const Hospital = this.roles.includes('Hospital');
    const Trailer = this.roles.includes('Trailer');
    const Repair = this.roles.includes('Repair');
    const Insurance = this.roles.includes('Insurance');
    const TrafficPolice = this.roles.includes('TrafficPolice');
    if ((Hospital || Trailer || Repair) && !admin && !Agent && !TrafficPolice) {
      this.comName = injuredForm;
    } else if(( Agent || TrafficPolice || Insurance) && !admin ) {
      this.comName = Edit;
    }else {
      this.comName = Edit;
    }
  }
};
</script>
<style lang="scss">
</style>
